/**
 * Mark metering state rows dirty so observe re-reads the metering provider.
 */
export class MarkMeteringDirtyRequest {
  tenantIds?: number[];
  meteringProviderCustomerIds?: string[];
}
